import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

export const createCustomerPortalSessionMutation = {
  mutationFn: (data: { customerId: string; returnUrl: string }): Promise<string> =>
    w.post(data, API_ENDPOINTS.payment.v1.subscription.stripe.portal['lawfully-pro'].index).json(),
}
